export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-5.png?d8c053004b9e67f6b6bb68cbbb5f0754";